import React from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom'

import "./App.css"
import Home from './Home';
import Viewer from './Viewer';
import NotFound from './NotFound';

export default function App() {

  return (
    <Router>
      <Routes>
      {/* {window.location.pathname.split("/")
        .includes("view") || window.location.pathname.split("/")
        .includes("viewer") ? ( */}
          <>
      <Route path='view/:viewerId' element={<Home/>} />
      <Route path='viewer/:viewerId' element={<Viewer/>} />
      </>
        {/* ) :
      <Route path={window.location.pathname} element={<NotFound/>} />
      } */}
      </Routes>
    </Router>
  );
}
